<template>
	<div class="chat_wrapper" @click="onClick($event)" id="chat_wrapper">
		<!-- 헤더 영역 -->
		<header-area
			:firstUser="helpShow"
			:userInfo="userInfo"
			:menuShow="menuShow"
	    :userLoginId="userNm"     
			@btnClick="addMessage"
		/>

		<!-- 채팅 영역 -->
		<ic-ans-message
			:messageList="messageList"
			:theme="theme"
			:chatbot="chatbot"
			:locale="'ko'"
			:wait="ansWait"
			@componentMessage="componentMessage"
		>			
			<template v-slot:message_footer="slotProps">
				<!-- chat foot start -->
				<div class="chat_foot">
					<div class="chat_date left">
						{{ $moment(slotProps.item.dt).format('a h:mm') }}
					</div>

					<!-- 좋아요/싫어요 start -->
					<div class="feedback_likehate">
						<span>답변이 도움되셨나요?</span>
						<ul class="chat_icon_set">
							<li>
								<button
									type="button"
									class="fas fa-thumbs-up btn_likehate like"
									:class="{
										on: slotProps.item.likeHate === 2,
										nohover: mobile,
									}"
									title="좋아요"
									@click="onClickFeedback(slotProps.item, 2)"
								/>
							</li>
							<li>
								<button
									type="button"
									class="fas fa-thumbs-down btn_likehate hate"
									:class="{
										on: slotProps.item.likeHate === 1,
										nohover: mobile,
									}"
									title="싫어요"
									@click="onClickFeedback(slotProps.item, 1)"
								/>
							</li>
						</ul>
					</div>
					<!--// 좋아요/싫어요 end -->
				</div>
				<!--// chat foot end -->
			</template>
		</ic-ans-message>

		<!-- 글쓰기 영역 -->
		<writing-area
			:userInfo="userInfo"
			:autoCompleteShow="autoCompleteShow"
			:faqShow="faqShow"
			:chatActive="chatActive"
			:writingDisable="ansWait"
			:messageList="messageList"
			@writeContent="addMessage"
		/>
	</div>
</template>

<script>
// eslint-disable-next-line no-undef
require('es6-promise').polyfill();
import storage from '../api/storage';
import HeaderArea from './HeaderArea.vue';
import WritingArea from './WritingArea.vue';
import config from '../config/config.json';
//import Crypto from '../api/crypto.js';
import CryptoJS from 'crypto-js';


export default {
	name: 'ChatArea',
	components: {
		'header-area': HeaderArea,
		'writing-area': WritingArea,
		// ...Infochatter3AnswerUikit,
	},
	data() {
		return {
      userInfo: {},
			messageList: [],
			ansWait: false,
			chatLog: [],
			helpShow: false,
			autoCompleteShow: true,   //cspring false -> true
			menuShow: false,
      faqShow: false,                //cspring false: 
			chatActive: false,
			theme: {
				class: 'basic',
				profile: {
					useYn: 'Y', // cspring "N"   => Y  아이콘 사용으로 변경,profile 보이기
				},
			},
			chatbot: {
				name: '사학연금',
				// img: '../assets/img_chatbot/profile/profile_default.png',
			},
      mobile: false,         
			loginId: '',             //spring
			cl_user: '',             //재직자상태값
			userNm:  '',
 //     ssoToken:'',        //사용하지 않음
			messageQue: {},     //spring
			loginMessageSeq: -1,
			tpPensionHome: null,   //연금홈새창
			isMobileApp : '',
		  };  //end return
		},    //end data()
		watch: {
			userInfo: function (val) {
				
			},
			loginId: function (val) {
			
				if (this.loginMessageSeq != -1) {
					this.messageList[this.loginMessageSeq].iuml = '<bubble class="icBubbleClass1"><text> 로그인되었습니다..</text></bubble>';
					this.sendMessage(this.messageQue.query, this.messageQue.dqml);
					window.focus();
				}

			},

		}, //end  watch  spring  추가
	/*	computed: {
      userInfoChange() {
        return this.sendMessage(this.messageQue.query, this.messageQue.dqml);
      }
		},*/
	created() {
		this.settingUserInfo();
 
	},
	mounted() {
		this.chatStartUp();
		this.mobile = this.mobileCheck();
  
		// 사학연금홈페이지에서 로그인 정보를 가지고 연결창을 띄울때 파라미터 id 는 userInfo 에 저장하고
		// url 의 href 에서는 파라미터 정보를 삭제처리한다

		if (this.mobile) {   //앱에서는 postmessage 방식이 아닌 get 방식으로 로그인정보를 챗봇 호출시 보낸다.
			var result = this.get_query();       
			if (result.data != undefined) {				
				let userInfoStr = CryptoJS.AES.decrypt(result.data, config.CRYPTO_KEY).toString(CryptoJS.enc.Utf8);
				let userInfo = JSON.parse(userInfoStr);
				this.userInfo.userId = userInfo.userId;
				this.loginId = userInfo.userId;
				this.cl_user = userInfo.cl_user;
				this.userNm = userInfo.userNm;
				this.isMobileApp = userInfo.app;				
			}
		}
  

		/*
    let url = document.location.href;
    let change_url = url.substring(0,url.indexOf('?'));
	
		var obj = { Title: "사학연금", ChangeUrl: change_url };
		history.pushState(obj, obj.Title, obj.ChangeUrl);
		*/

    //var obj = { Title: "사학연금", ChangeUrl: "change_url" };
   // history.pushState(obj, obj.Title, obj.ChangeUrl);

		//사학연금 부모창에서 보내는 메세지를 받을 수 있도록 등록
		window.addEventListener("message", this.receiveMessage, false);
  
  //  let cry = Crypto.cryptoAesEncrypt("test", config.CRYPTO_KEY);
		//  let decry = Crypto.cryptoAesDecrypt(cry, config.CRYPTO_KEY);
		/*
		if (this.mobile) {
			this.userInfo.userId = "bbsr";
			this.loginId = "bbsr";
			this.cl_user = "bbsr";
			this.userNm = "김혜경";
			this.isMobileApp = "true";
		}
		*/
		},    //end mounted()

	methods: {
		onClick(event) {
			
			const className = event.srcElement.className;
			const id = event.srcElement.id;

			this.autoCompleteShow =
				className === 'auto_complete' || id === 'send_input';

			if (className.match('btn_menu')) {
				this.menuShow = !this.menuShow;
			} else {
				this.menuShow = false;
			}

			if (className.match('btn_faq')) {
				this.faqShow = !this.faqShow;
			} else {
				this.faqShow = false;
			}
		},
		settingUserInfo() {
      const userData = storage.getUserData();
      this.userInfo.agentName = config.AGENT_NAME;
      this.userInfo.repoId = config.REPO_ID;

			if (userData) {
				this.userInfo.userId = userData.mbrId;
				this.userInfo.userNm = userData.mbrNm;
				if (userData.firstYn === 'Y' && !userData.lastLgnDt) {
					this.helpShow = true;
					userData.lastLgnDt = 'first';
					storage.setUserData(userData);
				} else {
					this.helpShow = false;
				}
			} else {
				this.userInfo.userId = config.USER_ID;
			}
		},
		mobileCheck() {
			const tempUser = navigator.userAgent;
			let isMobile = false;

			// userAgent 값에 iPhone, iPad, ipot, Android 라는 문자열이 하나라도 존재한다면 모바일로 간주됨.
			if (
				tempUser.indexOf('iPhone') > 0 ||
				tempUser.indexOf('iPad') > 0 ||
				tempUser.indexOf('iPod') > 0 ||
				tempUser.indexOf('Android') > 0
			) {
				isMobile = true;
			}
			return isMobile;
		},
		addChatLog(chatLog) {
			var vm = this;
			vm.chatLog += chatLog + '\n';
		},
		componentMessage(props) {
				console.log(props);	
				if (props.result || props.id ) {				// input이 여러개일 경우
					this.multiInput(props);     // 여러개의 input을 가질경우 값체크및 전달할 인자 값 설정
				} else {                          // 버튼만 있는경우
						this.addMessage(
							props.displayText,
							props.transferText.replace('&lt;', '<').replace('&gt;', '>'),
						);
				}   //else if
		},
		messagePush(messages, emotion) {
			if (!emotion) {
				emotion = 'BASIC';
			}
			messages.forEach(msg => {
				this.messageList.push({
					author: 'bot',
					iuml: msg.text,
					dt: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
					likeHate: '',
					emotion: emotion,
					index: this.messageList.length,
				});
			});
			this.ansWait = false;
			this.downScroll();
		},
		chatStartUp() {
			this.ansWait = true;
			const chatReqData = {
				agentName: this.userInfo.agentName,
				repoId: this.userInfo.repoId,
				sessionId: this.userInfo.sessionId,
				userId: this.userInfo.userId,
			};

			this.$axios
				.post(config.REST_API_PATH + '/chat/startup', chatReqData)       
				.then(response => {
					const { data } = response;
					this.userInfo.agentName = data.changeAgt
						? data.changeAgt
						: data.agentName;
					this.userInfo.sessionId = data.sessionId;

					if (data.chatActive && data.chatActive !== 'true') {
						this.messageList.forEach(msg => {
							msg.disabled = true;
						});
					}

					this.chatActive = data.chatActive ? data.chatActive === 'true' : true;

					setTimeout(() => {
						this.messagePush(data.messages, data.emotion);

					}, 1000);

					console.log('response.data >>> ', data);
					console.log('userInfo >>> ', this.userInfo);
				})
				.catch(error => {
          alert(error);				
				})
				.finally(() => {
					//스크롤 가장 아래
					this.downScroll();
				});
		},
		addMessage(chatText, query,dqml) {
			if (!this.chatActive) {
				this.messageList.forEach(msg => {
					msg.disabled = true;
				});
			}
			//화면에 사용자 말풍선 추가
			var userMessage = {
				author: 'user',
				text: chatText,
				query: query,
				dt: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
			};
			// this.messages.forEach(messages=>{
			//   messages.isDisabled=true;
			// })
			this.messageList.push(userMessage);
			this.downScroll();

			this.addChatLog('Q:' + userMessage.chatText);

			//메시지 전송 호출
			this.ansWait = true;
			this.faqShow = false;
			this.sendMessage(query,dqml);
		},
		//메시지 전송
		sendMessage(query,dqml) {
			var chatReqData = {
				agentName: this.userInfo.agentName,
				repoId: this.userInfo.repoId,
				sessionId: this.userInfo.sessionId,
				userId: this.userInfo.userId,
				query: query,
				dqml: dqml,
			};
			console.log(chatReqData);
      if ((this.userInfo.userId != undefined || this.userInfo.userId != "" )
				&& (chatReqData.dqml == undefined || chatReqData.dqml == "")) {
        let param = JSON.stringify({
					"userId": this.userInfo.userId,
					"ssoToken": this.ssoToken
        });
        //chatReqData.dqml = '{"userId" : "' + this.userInfo.userId  + '"}';
        chatReqData.dqml = param;
      }
			//화면에 챗봇 말풍선 추가
			this.$axios
				.post(config.REST_API_PATH + '/chat/message', chatReqData)
				.then(response => {
					const { data } = response;
					console.log(data.messages[0].text);
          //답변에 login 정보가 필요한 답변인지 확인하여
          // userInfo.userId 가 있으면 답변을 내보내고 아니면 로그인을 하는 답변으로 바꾸어 내보내기
					// 로그인을 기다려야 하는 상황이면 waitLoginList 에 추가하여 로그인후 그답변을 내보내도록 한다

          if (data.messages[0].text.indexOf('data="logCheck"') > -1 && (this.userInfo.userId == '' || this.userInfo.userId == undefined) ) {
						this.messageQue = { "query": query, "dqml": dqml };
						console.log("watch 에서 실행할 값 : ", this.messageQue);
						
						this.loginMessageSeq = this.messageList.length;

						data.messages[0].text = '<bubble class="icBubbleClass1"><text> 로그인이 필요합니다.</text>'+
              '<layout class="icLayoutClass2" > <button class="icBtnClass13" label="로그인" iClass="fas fa-external-link-alt" id="login"></button ></layout></bubble>';
             // '<layout class="icLayoutClass2" > <button class="icBtnClass13" label="로그인" iClass="fas fa-external-link-alt" src="http://localhost:8080/chatbot/tempHome.html" target="chatbotParent "></button ></layout></bubble>';
          };
					/////////////////////////////////////////////

					this.userInfo.agentName = data.changeAgt
						? data.changeAgt
						: data.agentName;
					this.userInfo.sessionId = data.sessionId;

					if (data.chatActive && data.chatActive !== 'true') {
						this.messageList.forEach(msg => {
							msg.disabled = true;
						});
					}

					this.chatActive = data.chatActive ? data.chatActive === 'true' : true;

					setTimeout(() => {
						this.messagePush(data.messages, data.emotion);
					}, 1000);

					console.log('response.data >>> ', data);
					console.log('userInfo >>> ', this.userInfo);
				})     //end then
				.finally(() => {
					//스크롤 가장 아래
					this.downScroll();
				});
			///////////////////////////////////////////
			/*
      let LogParam = {
        "userId": "test001",
        "userPw": "test001"
      };
 
			this.$axios
        .post(config.REST_API_PATH + '/sso/login',LogParam )
				.then(response => {
					const { data } = response;
					debugger;
					console.log("=============+++++++++log_result",data);
				});
				*/
			///////////////////////////////////////////



		},
		onClickFeedback(item, satiNum) {
			let actType;
			if (item.likeHate) {
				if (item.likeHate === satiNum) {
					actType = 'D'; // 취소
				} else {
					actType = 'U'; // 변경
				}
			} else {
				actType = 'I'; // 등록
			}

			const userQuery = this.messageList[item.index - 1];
			this.$axios
				.post(config.REST_API_PATH + '/chat/perf-rv/saveSatisfactionNum', {
					actType: actType,
					agtNm: this.userInfo.agentName,
					answer: item.iuml,
					id: actType !== 'I' ? item.satiId : null,
					qry: userQuery ? userQuery.query : null,
					repoId: this.userInfo.repoId,
					satisfactionNum: satiNum,
					sessId: this.userInfo.sessionId,
					userId: this.userInfo.userId,
				})
				.then(response => {
					const { data } = response;
					if (data.status) {
						// 피드백 성공
						if (actType === 'D') {
							item.likeHate = null;
							item.satiId = null;
						} else {
							item.likeHate = satiNum;
							item.satiId = data.id;
						}
					} else {
						alert('정상적으로 처리되지 않았습니다.');
					}
				})
				.catch(() => {
					alert('정상적으로 처리되지 않았습니다.');
					// console.log(error);
				});
		},
		downScroll() {
			// eslint-disable-next-line no-undef
			$('.chat_area').animate({
				// eslint-disable-next-line no-undef
				scrollTop: $('.chat_area')[0].scrollHeight,
			});
		},
		// 화면 리사이즈시 스크롤 아래
		bindWindowResize() {
			// eslint-disable-next-line no-undef
			$(window).resize(function() {
				this.downScroll();
			});
		},
		//url로 챗봇창이 호출 되어질때, parameter 가져오기
    get_query() {
			var url = document.location.href;
			var qs = url.substring(url.indexOf('?') + 1, url.length-2 ).split('&');
      for (var i = 0, result = {}; i < qs.length; i++) {
        qs[i] = qs[i].split('=');
        result[qs[i][0]] = decodeURIComponent(qs[i][1]);
      }
      return result;
    },


      //부모창에서 챗봇창으로 data 전달 시 호출
		receiveMessage(event) {
			
 			console.log(config.HOMEPAGE_URL + "===========" + event.origin);
			if (event.origin !== config.HOMEPAGE_URL) {
				return;
			}		

  	console.log(event.origin + " :  postEvent received ");

     // debugger;
			//let userInfoStr = Crypto.cryptoAesDecrypt(event.data, config.CRYPTO_KEY);
		   
			let userInfoStr = CryptoJS.AES.decrypt(event.data, config.CRYPTO_KEY).toString(CryptoJS.enc.Utf8);
      let userInfo = JSON.parse(userInfoStr);
      if (userInfo.userId) {
        if (this.loginId !== '' && this.loginId !== userInfo.userId) {    //|| this.loginId === event.data.userId 로그인 정보가 다르면 초기화한다
          this.messageList = [];
          this.chatStartUp();
				}
        this.userInfo.userId = userInfo.userId;
				this.loginId = userInfo.userId;
				this.cl_user = userInfo.cl_user;
				this.userNm = userInfo.userNm;
				this.isMobileApp = userInfo.app;
      
		}
			
     // event.source.postMessage("hi there yourself!  the secret response " + event.data , event.origin);      
		},
		multiInput(props) {      // input 값이 있을경우나 로그인버튼을 눌렀을 경우
      let transferMsgs = [];
			let displayMsgs = [];
			let inputCheck = true;
			if (props.result) {
				const keys = Object.keys(props.result);
						keys.forEach(key => {
							if (
								props.result[key].transferText &&
								props.result[key].transferText !== ''
							) {
								transferMsgs.push(props.result[key].transferText);
							}
							if (
								props.result[key].displayText &&
								props.result[key].displayText !== ''
							) {
								displayMsgs.push(props.result[key].displayText);
              } else {
                inputCheck = false;
                return false;
              }
							if (props.result[key].transferText_item) {
								transferMsgs.push(props.result[key].transferText_item);
							}
						});

			}  //end if (props.result)

			if (!inputCheck) {
				alert("조회 조건을 입력하세요.");
				return false;
      }
      let dqml = "";
      let transMsg = "";
      let dispMsg = "";
			if (props.id == 'login') {
				console.log("config.HOMEPAGE_URL : " + config.HOMEPAGE_URL);
				if (this.loginId !== '') {
					alert("이미 로그인 되었습니다.");
					return false;
				}
				let homeLink = null;    //모바일 네이버 로그인 새창 열기 지원하지 않아서 분기처리 함
				if (this.mobile) {
					const agt = navigator.userAgent.toLowerCase();
					if (agt.indexOf("android") > -1) {
						if (agt.indexOf("naver") > -1 || agt.indexOf("daum") > -1) {
              homeLink = window.open(config.HOMLOGIN_URI);
            } else {    //not mobile
              homeLink = window.open(config.HOMLOGIN_URI, "chatbotParent");   //chatbotParent
            };
					};
					if (agt.indexOf("iphone") > -1) {
            if (agt.indexOf("safari") > -1 || agt.indexOf("naver") > -1 || agt.indexOf("daum") > -1) {  //모바일 크롬이 아닌경우 새창으로 열기
              homeLink = window.open(config.HOMLOGIN_URI);
            } else {    //not mobile
              homeLink = window.open(config.HOMLOGIN_URI, "chatbotParent");   //chatbotParent
            };
					}

					/*
    
          if (agt.indexOf("android") > -1  &&  (agt.indexOf("naver") > -1 || agt.indexOf("daum") > -1)  ) {  //모바일 크롬이 아닌경우 새창으로 열기
            alert("새창으로 열기");
            homeLink = window.open(config.HOMLOGIN_URI);
          }else if (agt.indexOf("iphone") > -1 && agt.indexOf("safari") > -1) {  //모바일 크롬이 아닌경우 새창으로 열기
            alert("새창으로 열기");
            homeLink = window.open(config.HOMLOGIN_URI);
          }	else {   //모바일 크롬
            homeLink = window.open(config.HOMLOGIN_URI, "chatbotParent");
            alert("크롬으로 열기");
					}
					*/

				}else {    //not mobile
          homeLink = window.open(config.HOMLOGIN_URI, "chatbotParent");   //chatbotParent
				};


				homeLink.focus();
        return false;
      } else	if (props.id == 'weather') {
				if (!transferMsgs[0]) {
					alert("지역을 입력하세요");
					return false;
				} 
        //dqml = '{"city" : "' + transferMsgs[0] + '"}';
				dqml = JSON.stringify({
					"city": transferMsgs[0]
				});
        transMsg = "지역 날씨 알려줘";
        dispMsg = transferMsgs[0] + " 지역 날씨 알려줘";
      } else if (props.id == 'PayInfoLink') {    //퇴직급여조회		 재직중	 Link  모바일확인1
				let linkVal = "tch.sel::EsdPnaFQI.xfdl";
        if (this.mobile && this.isMobileApp == "false") {   //모바일 웹에서 접근할 때는 접근불가
					linkVal = "app.sel::EsdPnaFQI.xfdl";
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
				};
        if (this.mobile && this.isMobileApp == "true") {    //모바일 앱에서 접근할 때는 모바일 연금 호출
					linkVal = "app.sel::EsdPnaFQI.xfdl";
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
        };
        this.pentionLink(linkVal);
        return false;

      } else if (props.id == 'PayInfoOffLink') {    //퇴직급여조회			수급자 /퇴직자  Link   모바일확인2
        let linkVal = "ret.sel::ErdPnqFQL.xfdl";
        if (this.mobile && this.isMobileApp == "false") {     //모바일 웹에서 접근할 때는 접근불가
					linkVal = "app.sel::ErdPnqFQL.xfdl";
					alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
					return false;
				};
        if (this.mobile && this.isMobileApp == "true") {   //모바일 앱에서 접근할 때는 모바일 연금 호출
					linkVal = "app.sel::ErdPnqFQL.xfdl";
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
        };

        this.pentionLink(linkVal);
        return false;

      }else if (props.id == 'payInfo') {    //퇴직급여조회
				if (props.result == undefined) {
					alert("조건을 선택해주세요.");
					return false;
				}
				transMsg = transferMsgs.join();
        dispMsg = transMsg + " 내역 알려줘!";
        let param = {
          "userId": this.userInfo.userId,
        };
        dqml = JSON.stringify(param);	

      } else if (props.id == 'payStartAge') {    //연금 개시연령
        transMsg = "나의 연금개시연령 조회 확인";
				dispMsg =" 연금 개시 연령 알려줘!";
        let param = {
          "userId": this.userInfo.userId,
        };
        dqml = JSON.stringify(param);	

			} else if (props.id == 'payGiveList') {    //급여 지급내역 조회
        if (props.result == undefined) {
          alert("조건을 선택해주세요.");
          return false;
        }
        transMsg = transferMsgs.join() + " 급여지급 내역 알려줘";
        dispMsg = "급여지급 내역 알려줘. ";

        let param = {
          "userId": this.userInfo.userId,
          "type": transferMsgs[0]
        };
				dqml = JSON.stringify(param);

      } else if (props.id == 'payGiveListLink') {      //급여 지급내역 LInk
				let linkVal = "ret.sel::ErdPnrFQL.xfdl";
        if (this.mobile) {         
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
        };
        this.pentionLink(linkVal);
				return false;				

			} else if (props.id == 'condoList') {      //부조급여조회
        if (transferMsgs.length == 2) {
          alert("조건을 선택해주세요.");
          return false;
				};

        transMsg = transferMsgs.join();
        dispMsg = transferMsgs[0] + " ~ " + transferMsgs[1] + " 까지 " + transferMsgs[2] + "내역 알려줘! " ;
		   
				let param = {
					"userId": this.userInfo.userId,
					"startDt": transferMsgs[0],
					"endDt": transferMsgs[1],
          "type": transferMsgs[2]
				};
        dqml = JSON.stringify(param); 
      } else if (props.id == 'condoListLink') {      //부조급여LInk  모바일확인3
        let linkVal = "tch.sel::EsdPndFQL.xfdl";
        if (this.mobile && this.isMobileApp == "false") {
					linkVal = "app.sel::EsdPndFQL.xfdl"; 
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
				};

        if (this.mobile && this.isMobileApp == "true") {   //모바일 앱에서 접근할 때는 모바일 연금 호출
					linkVal = "app.sel::EsdPndFQL.xfdl";
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
        };

        this.pentionLink(linkVal);
        return false;
      } else if (props.id == 'disasterPay') {      // 재해보상금
        transMsg = "재해보상금 지급 내역 조회 확인";  
        dispMsg =" 재해 보상금 지급 내역 알려줘! ";
        dqml = JSON.stringify({ "userId": this.userInfo.userId});

      } else if (props.id == 'disasterPayLink') {      //재해보상금 LInk   모바일확인4
				let linkVal = "tch.sel::EsdPdfFQL.xfdl";
        if (this.mobile && this.isMobileApp == "false") {
					linkVal = "app.sel::EsdPdfFQL.xfdl";
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
				};

        if (this.mobile && this.isMobileApp == "true") {   //모바일 앱에서 접근할 때는 모바일 연금 호출
					linkVal = "app.sel::EsdPdfFQL.xfdl";
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
        };

        this.pentionLink(linkVal);
				return false;

      }	else if (props.id == 'levy') {      //기간계연계 > 부담금 > 조회
				transMsg = "부담금납부내역조회";  // transferMsgs.join();
				if (transferMsgs.length == 0) {
					dispMsg = "부담금 납부 내역 알려줘? ";
				} else {
					dispMsg = transferMsgs[0]  + " 이후 부담금 납부 내역 알려줘? ";
				}
				dqml = JSON.stringify({ "userId": this.userInfo.userId, "startDt": transferMsgs[0] });

      } else if (props.id == 'levyLink') {      //부담금 LInk   
				let linkVal = "tch.sel::EsdPlmFQL.xfdl";
        if (this.mobile) {        
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
				};
 
        this.pentionLink(linkVal);
        return false;
      }else if (props.id == 'workTerm') {      //일반>재직기간
        transMsg = "나의 재직 기간 내역 확인";  
        dispMsg ="재직 기간 알려줘! ";
				dqml = JSON.stringify({ "userId": this.userInfo.userId });
			} else if (props.id == 'rental') {           //대여잔액조회
        let param = {
          "userId": this.userInfo.userId};
        dqml = JSON.stringify(param);
       // transMsg = transferMsgs.join();
        dispMsg = "대여잔액 알려줘!";
				transMsg = "나의대여잔액조회하기";

			} else if (props.id == 'payApplyLink') {      //급여신청내역 LInk
        if (this.mobile) {        
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
        };

        let linkVal = "tch.app::EsePnrFQL.xfdl";
        this.pentionLink(linkVal);
        return false;
      }else if (props.id == 'rentalLink') {      //대여LInk    모바일확인5
				let linkVal = "ret.sel::ErdPotFQL.xfdl";
        if (this.mobile && this.isMobileApp == "false") {
					linkVal = "app.sel::ErdPotFQL.xfdl";
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
				};

        if (this.mobile && this.isMobileApp == "true") {   //모바일 앱에서 접근할 때는 모바일 연금 호출
					linkVal = "app.sel::ErdPotFQL.xfdl";
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
        };


				this.pentionLink(linkVal);
				return false;
			} else if (props.id == 'document') {      //문서 조회
        transMsg = transferMsgs.join();
        dispMsg = transferMsgs[0] + " ~ " + transferMsgs[1] + " 까지 " + " 문서처리 현황 알려줘. ";
        dqml = JSON.stringify({ "userId": this.userInfo.userId, "startDt": transferMsgs[0], "endDt": transferMsgs[1] });    
      } else if (props.id == 'documentLink') {      //문서 LInk  모바일확인6
        let linkVal = "tch.app::EsePacFQL.xfdl";
        if (this.mobile && this.isMobileApp == "false") {
					linkVal = "app.sel::EsePacFQL.xfdl";
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
				};

        if (this.mobile && this.isMobileApp == "true") {   //모바일 앱에서 접근할 때는 모바일 연금 호출
					linkVal = "app.sel::EsePacFQL.xfdl";
          alert("연금서비스 상세보기는 PC에서 이용하실 수 있습니다.");
          return false;
				};

        this.pentionLink(linkVal);
        return false;
      }

      console.log(displayMsgs.join() + "=========  " + transferMsgs.join());
      if (transMsg != '') {
        this.addMessage(dispMsg, transMsg, dqml);
      } else {
        this.addMessage(displayMsgs.join(), transferMsgs.join(), dqml);
      }
		}, //end multiInput()	
		pentionLink(linkVal) {            
       // this.tpPensionHome = window.open("http://localhost:8081/chatbot/pensiontempHome.html", "tpPensionHome");  //localTest용
 			 this.tpPensionHome = window.open(config.PENSIONHOME_URI + "/sc/cmmn/chatbotSend.do", "tpPensionHome");  // 실제웹용 	
       if (this.tpPensionHome == undefined) {
          alert("팝업창 차단을 해지해주세요.");
          return false;
        } 

      this.tpPensionHome.focus();
      let param = {
        "userId": this.userInfo.userId,
        "url": linkVal
      };
      console.log(config.PENSIONHOME_URI + "/sc/cmmn/chatbotSend.do" + "  param  : " + JSON.stringify(param));
      let paramCry = CryptoJS.AES.encrypt(JSON.stringify(param), config.CRYPTO_KEY).toString();
      setTimeout(() => {
       // tpPensionHome.postMessage(paramCry, "http://localhost:8081");    //localTest 용
         this.tpPensionHome.postMessage(paramCry, config.PENSIONHOME_URI);
			}, 2000);      
		},   // pentionLink end

		logInSSO() {   //SSO  연동 안하기로함
      let LogParam = {
        "userId": "test001",
        "userPw": "test001"
      };

      this.$axios
        .post(config.REST_API_PATH + '/sso/login', LogParam)
        .then(response => {
					const { data } = response;
					
        });
		}, //end logInVerify

    logInVerify() {    //SSO  연동 안하기로함
      let LogParam = {
        "log.loginVerify": this.ssoToken,
      };

      this.$axios
        .post(config.REST_API_PATH + '/sso/loginVerify', LogParam)
        .then(response => {
          const { data } = response;         
          console.log("=============+++++++++log_result", data);
        });
     }, //end logInVerify
		},    //end method

	//9월30일 최종
	};


</script>
<style scoped>
.nohover:hover {
	opacity: 0.3 !important;
	color: #000 !important;
}
.hate.on.nohover:hover {
	opacity: 1 !important;
	color: #4590ec !important;
}
.like.on.nohover:hover {
	opacity: 1 !important;
	color: #f46969 !important;
}
</style>






// WEBPACK FOOTER //
// src/components/ChatArea.vue